import type { ReactNode } from "react"

import { Card, CardContent } from "@/components/ui/card"
import { TableShell, type TableColumn } from "@/components/tableKit"
import type { TalentRow } from "@/components/talentBrowse/talentColumns"

export type TalentBrowseTableProps = {
    columns: TableColumn<TalentRow>[]
    rows: TalentRow[]
    empty: ReactNode
    pending?: boolean
    isLoading?: boolean
}

/** Browse table for pitching and New Booking. */
export function TalentBrowseTable({ columns, rows, empty, pending, isLoading }: TalentBrowseTableProps) {
    return (
        <div className={pending && !isLoading ? "opacity-60 transition-opacity" : "opacity-100 transition-opacity"} aria-busy={pending || isLoading || undefined}>
            <Card size="sm">
                <CardContent>
                    <TableShell
                        columns={columns}
                        rows={rows}
                        getRowId={(row) => row.talent.id}
                        empty={empty}
                        virtualize
                        isLoading={isLoading}
                    />
                </CardContent>
            </Card>
        </div>
    )
}
